var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/task",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(7.000000, 4.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8.25,
    y1: 14.261,
    x2: 13.5,
    y2: 14.261,
    id: "path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.25,
    y1: 18.761,
    x2: 13.5,
    y2: 18.761,
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25,13.886 C5.45710678,13.886 5.625,14.0538932 5.625,14.261 C5.625,14.4681068 5.45710678,14.636 5.25,14.636 C5.04289322,14.636 4.875,14.4681068 4.875,14.261 C4.875,14.0538932 5.04289322,13.886 5.25,13.886",
    id: "path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.25,
    y1: 9.761,
    x2: 13.5,
    y2: 9.761,
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25,9.386 C5.45710678,9.386 5.625,9.55389322 5.625,9.761 C5.625,9.96810678 5.45710678,10.136 5.25,10.136 C5.04289322,10.136 4.875,9.96810678 4.875,9.761 C4.875,9.55389322 5.04289322,9.386 5.25,9.386",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25,18.386 C5.45710678,18.386 5.625,18.5538932 5.625,18.761 C5.625,18.9681068 5.45710678,19.136 5.25,19.136 C5.04289322,19.136 4.875,18.9681068 4.875,18.761 C4.875,18.5538932 5.04289322,18.386 5.25,18.386",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75,4.511 L16.5,4.511 C17.3284271,4.511 18,5.18257288 18,6.011 L18,21.761 C18,22.5894271 17.3284271,23.261 16.5,23.261 L1.5,23.261 C0.671572875,23.261 0,22.5894271 0,21.761 L0,6.011 C0,5.18257288 0.671572875,4.511 1.5,4.511 L5.25,4.511 C5.25,2.43993219 6.92893219,0.761 9,0.761 C11.0710678,0.761 12.75,2.43993219 12.75,4.511 Z",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,3.761 C9.20710678,3.761 9.375,3.92889322 9.375,4.136 C9.375,4.34310678 9.20710678,4.511 9,4.511 C8.79289322,4.511 8.625,4.34310678 8.625,4.136 C8.625,3.92889322 8.79289322,3.761 9,3.761",
    id: "path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTask);
export default __webpack_public_path__ + "static/media/menu-task.4fe67768834db203b44b5fa60290f194.svg";
export { ForwardRef as ReactComponent };